// Stub file for courses navigation constants
const coursesPathSuffix = '/courses';

export default coursesPathSuffix;
